import { render, staticRenderFns } from "./BaseFileDropUploader.vue?vue&type=template&id=1501038a&scoped=true&"
import script from "./BaseFileDropUploader.vue?vue&type=script&lang=js&"
export * from "./BaseFileDropUploader.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileDropUploader.vue?vue&type=style&index=0&id=1501038a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501038a",
  null
  
)

export default component.exports